/**
 * Under a rule: the tags it tests that no enabled tag of its kind is named —
 * those conditions are unknown, so the rule does nothing.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { FC } from 'react';
import { Info } from 'lucide-react';
import type { DropGenRule, DropGenTagOption } from '@trafficpulse/shared';

import { RULE_SURFACES, type RuleSurface } from '../rule-surfaces';
import { missingTagsIn } from './tag-picker';

export const MissingTagNote: FC<{ rule: DropGenRule; catalog: DropGenTagOption[] | undefined; surface: RuleSurface }> = ({ rule, catalog, surface }) => {
  const missing = missingTagsIn(rule, catalog);
  if (missing.length === 0) return null;
  const { item, tags } = RULE_SURFACES[surface];
  return (
    <p className="flex items-start gap-1.5 text-xs text-warning" data-testid="rule-missing-tag">
      <Info className="mt-px h-3.5 w-3.5 shrink-0" aria-hidden />
      No enabled {item} tag is named {missing.map((n) => `"${n}"`).join(', ')} — those conditions are unknown and the rule does nothing.
      Pick another tag or re-create it on {tags.page}.
    </p>
  );
};
